'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var styles = require('@material-ui/core/styles');
var Menu = _interopDefault(require('@material-ui/core/Menu'));

// eslint-disable react/jsx-props-no-spreading
var StyledComponents = styles.withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        marginTop: '2px',
        paddingRight: '3px',
        paddingLeft: '3px',
    },
})(function (props) { return (React__default.createElement(Menu, tslib.__assign({ elevation: 0, getContentAnchorEl: null, anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    }, transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    } }, props))); });

module.exports = StyledComponents;
